"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.richTextContentFragment = void 0;
exports.richTextContentFragment = `
fragment richTextContent on RichTextContent {
  plainText
}
`;
//# sourceMappingURL=rich-text-content.js.map